import React, { useState } from 'react';
import '../assets/Drivers.css';
import { ordersApi } from '../utils/api';

interface DriverCardProps {
  driverId: string;
  driverName: string;
  driverNumber: string;
  onDelete?: () => void;
}

export const DriverCard: React.FC<DriverCardProps> = ({
  driverId, driverName, driverNumber, onDelete,
}) => {
  const [showModal, setShowModal] = useState(false);
  const [orders, setOrders] = useState<any[]>([]);
  const [loading, setLoading] = useState(false);

  const openOrders = async () => {
    setLoading(true);
    setShowModal(true);
    try {
      setOrders(await ordersApi.getAllDriverOrders(driverId));
    } catch {
      setOrders([]);
    } finally {
      setLoading(false);
    }
  };

  return (
    <>
      <div className="dcard" onClick={openOrders}>
        <div className="dcard__avatar">
          <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="1.9"
               strokeLinecap="round" strokeLinejoin="round">
            <path d="M20 21v-2a4 4 0 0 0-4-4H8a4 4 0 0 0-4 4v2" />
            <circle cx="12" cy="7" r="4" />
          </svg>
        </div>
        <div className="dcard__info">
          <h3 className="dcard__name">{driverName}</h3>
          <p className="dcard__phone mono">{driverNumber}</p>
        </div>
        <button
          className="dcard__del"
          onClick={e => { e.stopPropagation(); onDelete?.(); }}
          aria-label={`Delete driver ${driverName}`}
        >
          <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="1.9"
               strokeLinecap="round" strokeLinejoin="round">
            <path d="M3 6h18" />
            <path d="M19 6v14a2 2 0 0 1-2 2H7a2 2 0 0 1-2-2V6" />
            <path d="M8 6V4a2 2 0 0 1 2-2h4a2 2 0 0 1 2 2v2" />
          </svg>
        </button>
      </div>

      {showModal && (
        <div className="modal-overlay" onClick={() => setShowModal(false)}>
          <div className="modal-content" onClick={e => e.stopPropagation()}>
            <h2 style={{ marginBottom: 14 }}>Orders for {driverName}</h2>
            {loading ? (
              <div className="state"><p className="state__body">Loading…</p></div>
            ) : orders.length === 0 ? (
              <div className="state"><p className="state__body">No orders assigned yet.</p></div>
            ) : (
              <div className="dtable__wrap">
                <table className="dtable">
                  <thead>
                    <tr><th>Order</th><th>Item</th><th>Customer</th><th>Slot</th></tr>
                  </thead>
                  <tbody>
                    {orders.map((o, i) => (
                      <tr key={o.order_number ?? i}>
                        <td className="mono">{o.order_number}</td>
                        <td>{o.item || '—'}</td>
                        <td>{o.customer_name || '—'}</td>
                        <td>{o.time_slot || '—'}</td>
                      </tr>
                    ))}
                  </tbody>
                </table>
              </div>
            )}
            <button className="btn btn--secondary btn--block" style={{ marginTop: 16 }}
                    onClick={() => setShowModal(false)}>Close</button>
          </div>
        </div>
      )}
    </>
  );
};
